var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section container"},[_c('h1',{staticClass:"title has-text-primary"},[_vm._v(_vm._s(_vm.data.title))]),_c('h2',{staticClass:"subtitle has-text-black"},[_vm._v(_vm._s(_vm.data.intro))])])
}
var staticRenderFns = []

export { render, staticRenderFns }